import FormActionButtons from '@components/FormActionButtons';
import { FormLabel, Stack, TextField } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import React from 'react';

type ContactFormValues = {
    email: string;
    phoneNumber: string;
    social: {
        website: string;
        instagram: string;
        linkedin: string;
    };
};

type TalentContactsFormProps = {
    talent: any;
    loading?: boolean;
    onCancel: () => void;
    onSubmit: (values: ContactFormValues) => Promise<void> | void;
};

const TalentContactsForm = ({ talent, loading = false, onCancel, onSubmit }: TalentContactsFormProps) => {
    const defaultValues = React.useMemo<ContactFormValues>(
        () => ({
            email: talent?.email || '',
            phoneNumber: talent?.phoneNumber || '',
            social: {
                website: talent?.social?.website || '',
                instagram: talent?.social?.instagram || '',
                linkedin: talent?.social?.linkedin || '',
            },
        }),
        [talent],
    );

    const { control, handleSubmit, formState: { isDirty } } = useForm<ContactFormValues>({
        mode: 'all',
        defaultValues,
    });

    return (
        <Stack component="form" onSubmit={handleSubmit(onSubmit)} spacing={1.25} sx={{ pt: 1 }}>
            <Controller
                name="email"
                control={control}
                rules={{ required: 'Email requis' }}
                render={({ field, fieldState }) => (
                    <>
                        <FormLabel required>Email</FormLabel>
                        <TextField
                            {...field}
                            size="small"
                            type="email"
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                            disabled={loading}
                        />
                    </>
                )}
            />

            <Controller
                name="phoneNumber"
                control={control}
                rules={{ required: 'Portable requis' }}
                render={({ field, fieldState }) => (
                    <>
                        <FormLabel required>Portable</FormLabel>
                        <TextField
                            {...field}
                            size="small"
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                            disabled={loading}
                        />
                    </>
                )}
            />

            <Controller
                name="social.website"
                control={control}
                render={({ field }) => (
                    <>
                        <FormLabel>Site web</FormLabel>
                        <TextField {...field} size="small" disabled={loading} />
                    </>
                )}
            />

            <Controller
                name="social.instagram"
                control={control}
                render={({ field }) => (
                    <>
                        <FormLabel>Instagram</FormLabel>
                        <TextField {...field} size="small" disabled={loading} />
                    </>
                )}
            />

            <Controller
                name="social.linkedin"
                control={control}
                render={({ field }) => (
                    <>
                        <FormLabel>LinkedIn</FormLabel>
                        <TextField {...field} size="small" disabled={loading} />
                    </>
                )}
            />

            <FormActionButtons
                onCancel={onCancel}
                loading={loading}
                submitDisabled={!isDirty || loading}
                containerSx={{ pt: 0.5 }}
                size="small"
            />
        </Stack>
    );
};

export default TalentContactsForm;
